module.exports = __webpack_public_path__ + "img/check_simple_two_purple.c547de17.svg";